import { FC, useState } from 'react'
import { useIntl } from 'react-intl'

import { PatientRelativesAPI, PayloadCreatePatientRelative } from '@api/patientRelativesAPI'

import { ID } from '@models/base'
import { PatientRelativeModel } from '@models/patientRelative'

import { Button } from '@components/Button'

import { PatientRelativeFormShape } from '@modules/patient-relatives/components/PatientRelativeForm'
import { PatientRelativeFormDrawer } from '@modules/patient-relatives/components/PatientRelativeFormDrawer'
import { PermissionsControl } from '@modules/permissions'

import { PermissionEnum } from '@/constants/permission'
import FormUtil from '@/utils/formUtil'

type Props = {
  patientId: ID
  onCreated: (patientRelative: PatientRelativeModel) => void
}

const QueueNumberPatientRelativeCreateButton: FC<Props> = ({ patientId, onCreated }) => {
  const intl = useIntl()
  const [isShowDrawer, setIsShowDrawer] = useState<boolean>(false)

  const handleSubmit = async (formValues: PatientRelativeFormShape) => {
    const payload = FormUtil.formatValues<PayloadCreatePatientRelative>(
      FormUtil.parseValues<PayloadCreatePatientRelative>(formValues),
      {
        patient_id: () => patientId,
      }
    )

    const response = await PatientRelativesAPI.create(payload)

    if (response.data?.patient_relative) {
      onCreated(response.data.patient_relative)
    }

    setIsShowDrawer(false)
  }

  return (
    <PermissionsControl allow={PermissionEnum.PATIENT_CREATE}>
      <Button
        variant="icon"
        theme="primary"
        onClick={() => setIsShowDrawer(true)}
      >
        <i className="fa-solid fa-plus" />
      </Button>

      <PatientRelativeFormDrawer
        title={intl.formatMessage({ id: 'patient_relative.create.title' })}
        patientId={patientId}
        show={isShowDrawer}
        onHide={() => setIsShowDrawer(false)}
        onSubmit={handleSubmit}
      />
    </PermissionsControl>
  )
}

export default QueueNumberPatientRelativeCreateButton
